export default __webpack_public_path__ + "static/media/manageac_navicon-light.3db8355c.svg";